import React, { useState } from 'react';

import { SEO } from '@components';
import Modal from '@components/Modal';
import { Bulleted } from '@components/Lists';

// import telegram from '../img/telegram_icon.svg';
// import mail from '../img/mail.svg';
import ticket from '@img/ticket.svg';
import arrow_icon from '@img/down_arrow.svg';

const titleText = 'Contact Us';
const description =
	'Here is how you can get in touch with the Bitbns Team to get your queries sorted.';

const ContactUs = () => {
	const [openTelegramModal, setOpenTelegramModal] = useState(false);

	return (
		<>
			<SEO
				title={titleText}
				description={description}
				url="https://bitbns.com/contact-us/"
			/>

			<div className="text-white py-8">
				<div className="container">
					<h1 className="font-bold text-center mb-4 text-3xl">
						Need some help?
					</h1>
					<p className="text-center text-gray-300">
						Here’s how you can get in touch
					</p>
				</div>
			</div>
			<div className="bg-white">
				<div className="container mt-8 mb-16 p-10 w-4/5 lg:w-3/5">
					{/* <h2 className="text-lg text-gray-800 mb-12 text-center">
						Get your answers by clicking on support wizard below
					</h2>
					<p className="border-gray-300 border-t m-auto md:w-3/5 text-center relative">
						<span className="-translate-y-1/2 absolute bg-white p-3 transform">
							OR
						</span>
					</p> */}
					<div className="mb-32 mt-12">
						<a
							href="https://bitbns.freshdesk.com/support/home"
							rel="noreferrer nofollow noopener"
							target="_blank"
							className="bg-white flex flex-col items-center p-10 rounded hover:shadow-lg shadow text-center border border-separatorColor text-gray-600 hover:text-gray-900 cursor-pointer flex-grow max-w-lg m-auto"
						>
							{/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */}
							<img src={ticket.src} alt="ticket" />
							<span className="mt-3">Raise a Ticket</span>
						</a>

						{/* <a
						href="mailto:support@bitbns.com"
						className="bg-white flex flex-col items-center p-10 rounded hover:shadow-lg shadow text-center border border-separatorColor text-gray-600 hover:text-gray-900 cursor-pointer flex-grow my-16 md:mx-10 md:my-0"
					>
						<img src={mail} alt="mail" />
						<span className="mt-3">Send us an E-mail</span>
					</a> */}

						{/* <div
						className="bg-white flex flex-col items-center p-10 rounded hover:shadow-lg shadow text-center border border-separatorColor text-gray-600 hover:text-gray-900 cursor-pointer flex-grow"
						onClick={() => {
							setOpenTelegramModal(true);
						}}
					>
						<img src={telegram} alt="telegram" />
						<span className="mt-3">Contact a Telegram Admin</span>
					</div> */}
					</div>
					<div className="border-t border-gray-300 md:w-3/5 m-auto pt-10 my-10">
						<p className="font-semibold text-redOrangified">
							Important
						</p>
						<p className="my-5 text-gray-800">
							Beware of fake scammers on Telegram. Follow these
							precautions:
						</p>
						<Bulleted.Ul className="ml-6 text-gray-800">
							<Bulleted.Li className="my-3">
								Don’t give your e-mail ID, Password or OTP to
								anyone.
							</Bulleted.Li>
							<Bulleted.Li className="my-3">
								Don’t send money to anyone claiming to be from
								Bitbns/Bitdroplet.
							</Bulleted.Li>
							<Bulleted.Li className="my-3">
								There is no “bot address or rectification
								process.”
							</Bulleted.Li>
							<Bulleted.Li className="my-3">
								Bitbns will never message you first.
							</Bulleted.Li>
						</Bulleted.Ul>
					</div>
				</div>
			</div>

			<Modal
				openMoi={openTelegramModal}
				header="Contact a Telegram Admin"
				bodyClassName="p-0"
				modalClose={() => {
					setOpenTelegramModal(false);
				}}
				small
			>
				<p className="p-8 text-gray-700">
					You can contact any of these official Telegram Admins
				</p>
				<a
					href="https://telega.one/vbhvsth"
					target="_blank"
					rel="noopener noreferrer"
					className="p-8 c-links flex justify-between border-t border-b border-gray-300"
				>
					Vaibhav Seth
					<img
						/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */
						src={arrow_icon.src}
						alt="arrow"
						width="15"
						className="-rotate-90 transform"
					/>
				</a>
				<a
					href="https://telega.one/nitinvaid"
					target="_blank"
					rel="noopener noreferrer"
					className="p-8 c-links flex justify-between"
				>
					Nitin Vaid
					<img
						/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */
						src={arrow_icon.src}
						alt="arrow"
						width="15"
						className="-rotate-90 transform"
					/>
				</a>
			</Modal>
		</>
	);
};

export default ContactUs;
